
import React, { Component } from 'react';
import FinChartDash from './FinChartDash';

export default class Products extends Component {
    state = {
        value: 0,
      };
    render(){
        return(
            <div>
                    <h5>Products</h5>
            <p>
                We strive for quality.
                <br /><br />
                We offer a few off the shelf products that can help your current workflows as well as save money
                on hardware. OUr systems are all cloud based and have no middle men in the technical side
                so from the database to the application code - it's all in the cloud hosted using Googles systems.
                In terms of benefits - this means for you more transparency, clear development channel and robust secuirty and code
                to name a few.
               <br /><br />
            
            </p>

            <h6>One of our products: <div style={{color: '#1E90FF'}}>DLStockr</div></h6>
           
            This is a Fully Mobile Friendly Stock and Inventory Control System. 
            Our App makes it easy to store, edit and manage stock – 
            whether your on your laptop or mobile phone.

            The fully featured app includes:
            <ul>
                    <li>Dashboard based design for quick overview of stock</li>
                    <li>Secure area for Admins</li>
                    <li>Mobile compatiable and cross platform</li>
                    <li>Firebase Authentication</li>
                    <li>Firebase Database hosting for stock items</li>
                    <li>Firebase Hosting</li>
                    <li>Strong enough for Enterprise level systems and environments <br /></li>
            - app is fast and backend is scalable. No worries here.
            </ul>
            <br />
            Click here to try the demo: <a href="http://dlstockr.firebaseapp.com">DLStockr</a>
            <br />
            Why our app?
            A robust and mobile friendly app that's easy to use and deploy to your server too               
            
            <br /> <br /> <br /> <br /> <br />
        
            <div style={{color: '#1E90FF'}}>DLCMS</div> 
            Our App makes it easy to create and manage your React based website – 
            whether your on your laptop or mobile phone.
            <br />
            This is a CMS which requires no technical knowledge from end users to edit your website.
            <br /><br />
            How it works: <br />
            A developer uses it to build your website for you - a free template is included. 
            This developer can be a hired one or someone in your current dev team.
            Then they can deploy the whole app online.
            From there on you, or any non techy can log in to the front end to edit the website. <br />

            <br />
            The fully featured app includes: <br />
                <ul>
                <li>Dashboard based design for quick overview of pages <br /></li>
                <li>Secure area for Admins <br /></li>
                <li>Strong enough for Enterprise level systems and environments <br /></li>
            - app is fast and backend is scalable. No worries here.</ul>

            
            
            Why our app? <br />
            A robust and mobile friendly app that's easy to use and deploy to your server too <br />
            <br />
            <br /><br />
            <div style={{color: '#1E90FF'}}>Consultancy Services</div>
           We also for Azure Cloud and it's API.

           Below are the current areas of work we can cover with it.

           Similar to to the Azure DevOps Consultancy Services - We offer Consultancy Services
           also for Google Cloud and it's API.

           Below are the current areas of work we can cover with it.
                              
        
                <br /><br />
             Serverless Architecture is becoming common place and businesses from small to large enterprises
              which means one of the most Server-less server - Express, is being used but also the engine
              for it i.e. NodeJS.

              We offer full end to NodeJS and Express application design and build services as well design and
              host the whole serverless infrastruture behind it inclduing build and CI tooling and process.

              Like all our work - it's all documented too.

</div>
        );
    }
  }


// WEBPACK FOOTER //
// ./src/components/Products.js